// Splits a string into words and reveals them one-by-one on load.
export const WordReveal = ({ text, className = "", start = 0, step = 90 }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((word, i) => (
        <span className="word-reveal" key={i}>
          <span style={{ animationDelay: `${start + i * step}ms` }}>
            {word}
          </span>
          {i < words.length - 1 ? "\u00A0" : ""}
        </span>
      ))}
    </span>
  );
};
